import { render } from "./EconomyDeathsTable.vue?vue&type=template&id=4fef7004&ts=true"
import script from "./EconomyDeathsTable.vue?vue&type=script&lang=ts"
export * from "./EconomyDeathsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__